import LegalShell, { Section } from "@/components/public/LegalShell";
import { useLang } from "@/i18n/LanguageContext";

export default function Privacidad() {
  const { t, lang } = useLang();
  const P = t.privacy;
  const dateStr = new Date().toLocaleDateString(lang === "en" ? "en-US" : "es-ES", { year: "numeric", month: "long", day: "numeric" });
  return (
    <LegalShell testid="page-privacidad" eyebrow={P.eyebrow} title={P.title} intro={P.intro}>
      <p className="text-sm text-muted-foreground mb-8">{P.updated} {dateStr}</p>
      {P.sections.map((s) => (
        <Section key={s.title} title={s.title}>
          {s.ps.map((p, i) => <p key={i}>{p}</p>)}
          {s.list && (
            <ul className="list-disc pl-5 space-y-1.5">
              {s.list.map((li, i) => <li key={i}>{li}</li>)}
            </ul>
          )}
          {s.after && <p>{s.after}</p>}
        </Section>
      ))}
    </LegalShell>
  );
}
